<button (click)="openSidenav.emit()" class="button" matTooltip="Open Menu" matTooltipPosition="below"
  aria-label="Open Menu" matTooltipClass="table_tooltip_job_filename" fxHide.gt-sm mat-icon-button>
  <mat-icon>menu</mat-icon>
</button>